module.exports = __webpack_public_path__ + "static/img/dianqi.c1ae5b6d.png";